import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOfficeDeductHistTable extends Layout {
    sourceOffDeductHist: DataSource;
    tableDeduction: Table;
}
